import { createAsyncSagaAction } from 'utils/reduxUtils';
import * as actionTypes from './actionTypes';

export const saveMyProfile = createAsyncSagaAction(actionTypes.SAVE_MY_PROFILE);
